export const CMS_ASSISTANT_SEARCH_REPORT_EXPORT_ENDPOINT =
	"api/v1/cmsAssistant/searchReports/export";

export const mapCmsAssistantExportSortField = (reportKey, sortField) => {
	if (!sortField) return "";
	if (reportKey === "searchTerms" || reportKey === "zeroKeywordResults") {
		const m = {
			query: "query",
			volume: "count",
			count: "count",
			zeroResultPct: "zeroResultPct",
		};
		return m[sortField] || sortField;
	}
	return sortField;
};
